/* eslint-disable @typescript-eslint/no-unsafe-return */
/** h5Auth SDK说明：https://hellobike.yuque.com/gzxsb9/iank77/bwuxp2?singleDoc */
/** systemCode枚举说明： http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=57034434 */
import { env } from '@/constant';
import { ENV, IUserInfo } from '@hb/H5Auth/dist/model';
import { Toast } from '@hb/coffee';

import { LoginTypeEnum } from '@/enums/loginTypeEnum';
import URLUtils from '../utils/URLUtils';


const { systemCode = '' } = URLUtils.getQueryMap();

export const getUnionAuthCode = (): string => {
  const {
    authCode,
    AppFinanceH5WebLoginType = '',
    /** 为适配中原外采增加的字段，用来标识当前联登的字段取值 */
    AppFinanceH5WebLoginKey,
  } = URLUtils.getQueryMap();

  const LOGIN_CODE = (URLUtils.getQueryMap())[AppFinanceH5WebLoginKey as string] as string || '';

  if (String(AppFinanceH5WebLoginType).toUpperCase() === LoginTypeEnum.UNION) {
    return AppFinanceH5WebLoginKey
      ? LOGIN_CODE : authCode as string;
  }
  return '';
};


/** 标准模式下的三方联登接口登录 */
export const unionAuth = async ():Promise<IUserInfo> => {
  const authModule = await import(/* webpackChunkName: "h5-auth" */'@hb/H5Auth');
  const h5Auth = new authModule.H5Auth();

  h5Auth.initConfig({
    env: env as ENV,
    systemCode: (systemCode || 'Am3') as string,
  });

  const authCode = getUnionAuthCode();

  try {
    const res = await h5Auth.preSignIn({
      standard: true, // 【必需】
      authCode, // 三方App在运行时提供的用户信息加密串
    });
    return res;
  } catch (err) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    Toast('登录失败，请重新登录');
    return { token: '' };
  }
};
